import { useDrop } from 'react-dnd'
import styles from './Card.module.scss'
import ImageDropCursor from './assets/drop_cursor.svg?react'
import { SllCourse, SllLesson } from '@src/api/graphql-codegen';


type Props = {
  accept: string
  source: number
  onDrop: (item: SllLesson) => void
  course?: SllCourse
  isMovable: boolean
}

function HoverColor(col, amt) {
  
    var usePound = false;  
    if (col[0] === "#") {
        col = col.slice(1);
        usePound = true;
    } 
    var num = parseInt(col,16);
    var r = (num >> 16) + amt;
 
    if (r > 255) r = 255;
    else if  (r < 0) r = 0;
 
    var b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255) b = 255;
    else if  (b < 0) b = 0;
 
    var g = (num & 0x0000FF) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
 
    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}

function DropBox(props: Props) {
    const { accept, course, isMovable, onDrop } = props
    
    const color = `${course?.color}`;
    const darkColor = `${course?.darkColor}`;

    const [{ isOver, canDrop }] = useDrop({
        accept,
        drop: onDrop,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    })

    const isActive = isOver && canDrop
    let dropCardStyle = styles.dropGradeCard
    let label = "Drag and Drop Lessons"

    if (isActive) {
        dropCardStyle = styles.dropGradeCard
    } else if (canDrop || isMovable) {
        dropCardStyle = styles.dropUnitsCard
        label = "Drag and Drop Lessons Here"
    }
    const hoverColor = HoverColor(color, -30);
    return (
        <div className={dropCardStyle} style={{background: canDrop ? hoverColor : isMovable ? '#D4EAEC' : color, border: `1px solid ${darkColor}`}}>
            <div className={styles.box}>
                <ImageDropCursor className={styles.dropImage} fill={canDrop ? hoverColor : isMovable ? '#D4EAEC' : color} stroke={(canDrop || isMovable) ? "#FFF" : darkColor}/>
                <p className={styles.labelPadding} style={{color: (canDrop || isMovable) ? "#FFF" : darkColor}}>{label}</p>
            </div>
        </div>
    )
}

export default DropBox
